import { useMemo } from 'react'

import { getBrand } from 'pared/utils/brand'

interface IConfig {
  isSalesMix: boolean
}

const defaultConfig = { isSalesMix: false }

const useConfig = (): IConfig => {
  const brand = getBrand()

  return useMemo(() => {
    switch (brand) {
      case 'mwb':
      case 'burgerworks':
        return {
          ...defaultConfig,
          isSalesMix: true,
        }
      default:
        return defaultConfig
    }
  }, [brand])
}

export default useConfig
